import "./index.css";
import "./global.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "antd/dist/reset.css";
import "react-toastify/dist/ReactToastify.css";
import Router from "./router/index";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import Colors from "./constant/colors";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement
);

// antd tokens aligned with the practitioner / user-web theme
const antdTheme = {
  token: {
    colorPrimary: Colors.primaryBlue,
    colorInfo: Colors.info,
    colorSuccess: Colors.success,
    colorWarning: Colors.warning,
    colorError: Colors.error,
    colorText: Colors.textPrimary,
    colorTextSecondary: Colors.textTertiary,
    colorBorder: Colors.gray200,
    colorBgLayout: Colors.screenBackground,
    fontFamily: "'Poppins', sans-serif",
    borderRadius: 12,
  },
};

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={antdTheme}>
        <Router />
        <ToastContainer />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
